import React from 'react'
import Input from '../../../../shared/component/inputFields'

const AssignedRep = () => {
    function handelCopy(e) {
    }   
  return (
    <div className='assignedRep'>
        <div className='row'>
            <div className='col-lg-5 col-md-6'>
                <h1 className='title'>Representative Info</h1>
                <Input type="text" label="Representative Name:" value="Ali Mahmoud" readonly />
                <Input type="text" label="Phone:" value="+01004790382" readonly copy Oncopy={handelCopy} />
            </div>
        </div>
    </div>
  )
}

export default AssignedRep